import { FC } from 'react';
import { Flex, SxStyleProp } from 'theme-ui';
import Icon from './Icon';
import CloseTagSvg from '../../assets/icons/closeTag.svg';

const tagLeftStyles: SxStyleProp = {
  position: 'absolute',
  cursor: 'pointer',
  width: 26,
  height: 76,
  ':hover': {
    '.close-tag-arrow': {
      path: {
        fill: 'text'
      }
    }
  }
};

const closeTagStyles = { width: '100%', fill: 'background' };

type CloseTagProps = {
  isOpen: boolean;
  handleClick: () => void;
  className?: string;
};

export const CloseTag: FC<CloseTagProps> = ({ isOpen, handleClick, className }: CloseTagProps) => (
  <Flex sx={tagLeftStyles} onClick={handleClick} className={className}>
    <CloseTagSvg sx={closeTagStyles} />
    <Icon
      className="close-tag-arrow"
      name="arrow-left-gen"
      sx={{
        width: 13,
        height: '100%',
        marginLeft: '-19px',
        transform: isOpen ? null : 'rotate(180deg)',
        zIndex: 'arrow',
        display: 'flex',
        path: {
          fill: 'muted3'
        }
      }}
    />
  </Flex>
);
